export {default} from './TextDivider';
